export default "__VITE_ASSET__ABD_cG7H__"